import {RouterModule, Routes} from "@angular/router";
import {AuthenticationService} from "../shared/authentication.service";
import {MessagesComponent} from "./messages/messages.component";
import {CompaniesResolver}                   from "../shared/resolvers/companies.resolver";
import {UsersResolver}                       from "../shared/resolvers/users.resolver";
import {LanguagesGroupedResolver}            from "../shared/languages.resolver";
import {CanDo}                               from "../shared/CanDo";
import {Permission}                          from "../shared/api/permissions/api.models";
import {UserPerformanceComponent}            from "./userPerformance/userPerformance.component";
import {messageStatsComponent}               from "./messagesStatistics/messageStats.component";
import {GroupedBasesResolver} from "../shared/resolvers/bases.resolver";

const routes: Routes = [
    {
        path : 'statistics/users',
        component: MessagesComponent,
        canActivate : [AuthenticationService, CanDo],
        resolve : {
            companies: CompaniesResolver,
            users : UsersResolver,
            languages: LanguagesGroupedResolver
        },
        data : {
            canDo : [
                Permission.STATISTICS_MESSAGES
            ],
            allLanguages: true
        }
    },
    {
        path : 'statistics/user-performance',
        component: UserPerformanceComponent,
        canActivate : [AuthenticationService],
        resolve : {
            companies: CompaniesResolver,
            users : UsersResolver
        }
    },
    {
        path : 'statistics/messages',
        component: messageStatsComponent,
        canActivate : [AuthenticationService],
        resolve: {
            bases: GroupedBasesResolver
        },
    }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/statistics/statistics.routing.ts